import React from 'react';
import { Box, Typography, Button, Container, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface CTASectionProps {
  title: string;
  subtitle: string;
  buttonLabel: string;
  buttonPath: string;
  variant?: 'default' | 'dark';
}

const CTASection: React.FC<CTASectionProps> = ({
  title,
  subtitle,
  buttonLabel,
  buttonPath,
  variant = 'default',
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        backgroundColor: variant === 'dark' ? '#000000' : 'rgba(0, 0, 0, 0.02)',
        color: variant === 'dark' ? '#ffffff' : 'inherit',
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: '2rem', md: '2.5rem' },
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: variant === 'dark' ? 'rgba(255, 255, 255, 0.8)' : 'text.secondary',
              mb: 4,
              fontSize: { xs: '1rem', md: '1.125rem' },
            }}
          >
            {subtitle}
          </Typography>
          <Button
            variant={variant === 'dark' ? 'contained' : 'contained'}
            size="large"
            onClick={() => navigate(buttonPath)}
            sx={{
              minWidth: { xs: '100%', sm: '250px' },
              py: 1.5,
              px: 4,
              fontSize: '1rem',
              fontWeight: 600,
              backgroundColor: variant === 'dark' ? '#ffffff' : '#000000',
              color: variant === 'dark' ? '#000000' : '#ffffff',
              '&:hover': {
                backgroundColor: variant === 'dark' ? 'rgba(255, 255, 255, 0.9)' : '#333333',
              },
            }}
          >
            {buttonLabel}
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default CTASection;
